import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query'

import {
    createEquipmentYard,
    listActiveEquipmentYards,
    listAllEquipmentYards,
    updateEquipmentYard,
} from './api'
import {equipmentYardKeys} from './query-keys'
import type {CreateEquipmentYardInput, UpdateEquipmentYardInput} from './schemas'

export function useActiveEquipmentYards(options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: equipmentYardKeys.active(),
        queryFn: listActiveEquipmentYards,
        enabled: options?.enabled ?? true,
    })
}

export function useAllEquipmentYards(options?: {enabled?: boolean}) {
    return useQuery({
        queryKey: equipmentYardKeys.allList(),
        queryFn: listAllEquipmentYards,
        enabled: options?.enabled ?? true,
    })
}

export function useCreateEquipmentYard() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: (input: CreateEquipmentYardInput) => createEquipmentYard(input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: equipmentYardKeys.all})
        },
    })
}

export function useUpdateEquipmentYard() {
    const queryClient = useQueryClient()
    return useMutation({
        mutationFn: ({id, input}: {id: string; input: UpdateEquipmentYardInput}) =>
            updateEquipmentYard(id, input),
        onSuccess: () => {
            void queryClient.invalidateQueries({queryKey: equipmentYardKeys.all})
        },
    })
}
